import React, { useEffect, useRef } from 'react';
import {
  DefaultMessage,
  NpsMessage,
  PrescriptionMessage,
  EducationMessage,
  StartVisitMessage,
  RequestPhotoMessage,
  PhotoUploadMessage,
  PhoneCallBackMessage,
} from 'app/components/widgets/chat/message-types';

const RENDERERS = {
  default: DefaultMessage,
  nps: NpsMessage,
  // treatment plan messages are deprecated, but there are still old messages in our system that we need to handle
  treatment_plan: () => null,
  retake_photos: RequestPhotoMessage,
  phone_call_back: PhoneCallBackMessage,
  prescription: PrescriptionMessage,
  start_visit: StartVisitMessage,
  education: EducationMessage,
  request_photo: RequestPhotoMessage,
  photo_upload: PhotoUploadMessage,
};

const observerOptions = {
  rootMargin: '0px',
  threshold: 1.0,
};

interface MessageProps {
  message: any;
  user: any;
  onActionClick: any;
  onVisible: any;
  messageContainerRef: any;
  scrollToBottom: any;
}

function Message({ message, user, onActionClick, onVisible, messageContainerRef, scrollToBottom }: MessageProps) {
  const messageRef = useRef();

  useEffect(() => {
    if (messageRef.current && 'IntersectionObserver' in window) {
      const interaction = new IntersectionObserver(() => onVisible(message), observerOptions);
      interaction.observe(messageRef.current as any);
      messageContainerRef(messageRef.current);
    }
  }, []);

  const MessageComponent = RENDERERS[message.type] || RENDERERS.default;
  return (
    <MessageComponent
      messageRef={messageRef}
      message={message}
      fromCurrentUser={message?.fromId === user?.id}
      onActionClick={() => onActionClick(message)}
      scrollToBottom={scrollToBottom}
    />
  );
}

export default React.forwardRef((props: any, ref) => <Message messageContainerRef={ref} {...props} />);
